import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  rates: null,
  discounts: null,

  discountPriceBuy: null,
  orderTestStatus: null,

  servers: null,
  serversPagination: null,

  editCommentStatus: null,
  discountPriceRenew: null,
  renewStatus: null,
  toggleAutopayStatus: null,
  startStatus: null,
  shutdownStatus: null,
  rebootStatus: null,
  upgradeStatus: null,
}

export const vpsSlice = createSlice({
  name: 'vps',
  initialState,
  reducers: {
    setServerRates: (state, action) => { state.rates = action.payload },
    setServerDiscounts: (state, action) => { state.discounts = action.payload },

    setDiscountPriceBuy: (state, action) => { state.discountPriceBuy = action.payload },
    setOrderTestStatus: (state, action) => { state.orderTestStatus = action.payload },

    setServersList: (state, action) => { state.servers = action.payload },
    setServersListPagination: (state, action) => { state.serversPagination = action.payload },

    setEditCommentStatus: (state, action) => { state.editCommentStatus = action.payload },
    setDiscountPriceRenew: (state, action) => { state.discountPriceRenew = action.payload },
    setRenewStatus: (state, action) => { state.renewStatus = action.payload },
    setToggleAutopayStatus: (state, action) => { state.toggleAutopayStatus = action.payload },
    setStartStatus: (state, action) => { state.startStatus = action.payload },
    setShutdownStatus: (state, action) => { state.shutdownStatus = action.payload },
    setRebootStatus: (state, action) => { state.rebootStatus = action.payload },
    setUpgradeStatus: (state, action) => { state.upgradeStatus = action.payload },

    resetVps: () => initialState,
  },
})

export const {
  setServerRates,
  setServerDiscounts,

  setDiscountPriceBuy,
  setOrderTestStatus,

  setServersList,
  setServersListPagination,

  setEditCommentStatus,
  setDiscountPriceRenew,
  setRenewStatus,
  setToggleAutopayStatus,
  setStartStatus,
  setShutdownStatus,
  setRebootStatus,
  setUpgradeStatus,

  resetVps,
} = vpsSlice.actions

export default vpsSlice.reducer